import React from "react";

const OverrideComplianceOfBank = ({ cls }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 24 24"
      className={cls}
    >
      <path
        d="m22.535,6.122l-3.656-3.657c-.944-.944-2.2-1.464-3.536-1.464h-4.343c-2.206,0-4,1.794-4,4v5c0,.552.447,1,1,1s1-.448,1-1v-5c0-1.103.897-2,2-2h4v4c0,1.654,1.346,3,3,3h4v9c0,1.103-.897,2-2,2h-9c-1.103,0-2-.897-2-2v-1c0-.553-.447-1-1-1s-1,.447-1,1v1c0,2.206,1.794,4,4,4h9c2.206,0,4-1.794,4-4v-9.343c0-1.335-.521-2.591-1.465-3.535Zm-5.535.878v-3.502c.165.11.321.236.465.38l3.656,3.657c.142.142.268.298.377.464h-3.498c-.552,0-1-.449-1-1Zm-11,15c0,.553-.447,1-1,1h-1c-2.206,0-4-1.794-4-4V5C0,2.794,1.794,1,4,1h1c.553,0,1,.448,1,1s-.447,1-1,1h-1c-1.103,0-2,.897-2,2v14c0,1.103.897,2,2,2h1c.553,0,1,.447,1,1Zm-1-9h8.095l-1.802-1.793c-.391-.391-.391-1.024,0-1.415.391-.39,1.023-.39,1.414,0l2.799,2.801c.387.387.581.896.581,1.405,0,0,0,0,0,.001,0,0,0,0,0,.001,0,.509-.193,1.017-.58,1.404l-2.8,2.802c-.195.195-.451.293-.707.293s-.512-.098-.707-.293c-.391-.39-.391-1.023,0-1.414l1.792-1.793H5c-.553,0-1-.447-1-1s.447-1,1-1Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default OverrideComplianceOfBank;
